import './styles.css'
const Spinner = () => {
  return (
    <div className="loading">
      <span className="spinner spinner--dotted"></span>
    </div>
  )
}

export default Spinner
